export default __webpack_public_path__ + "static/media/add-photo.a58f0edc.svg";